import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
import axios from 'axios'
import commonUtil from './util/commonUtil'
import arrayUtil from './util/arrayUtil'
import fileUtil from './util/fileUtil'
import dateUtil from "@/util/dateUtil";

import mavonEditor from 'mavon-editor'

import "element-ui/lib/theme-chalk/index.css"
import 'mavon-editor/dist/css/index.css'

import '@/assets/css/my_icon.css'
import '@/assets/css/system.css'
import '@/assets/font/font.css'

import "./axios"
import "./permission"

Vue.use(Element, {
  message: {
    duration: 1000  // 设置全局默认显示时长为 1 秒
  }
})
Vue.use(mavonEditor)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.commonUtil = commonUtil
Vue.prototype.arrayUtil = arrayUtil
Vue.prototype.fileUtil = fileUtil
Vue.prototype.dateUtil = dateUtil

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
